module.exports = __webpack_public_path__ + "media/images/app/invoice-a82b54e981374439263e66e47f6ee019.svg";